import React, { Component } from 'react';

import RowIntegrante from './RowIntegrante';

function createArrayTable(integrantes){
    //ME ASEGURO DE QUE EL TITULAR DE LA CUENTA QUEDE EN EL PRIMER INDICE DEL ARREGLO
    integrantes.map((item,i)=>{
        if(item.VinculoTarjeta=="Titular" && item.EstadoTarjeta =="Operativa"){
            integrantes.splice(i, 1);
            integrantes.unshift(item);
        }
    });
    //GENERO UN ARREGLO CON INTEGRANTES Y SUS TARJETAS COMO LO REQUIERE LA TABLA
    let arrAux=[];

    integrantes.map((int,i)=>{
        if(!arrAux.some(x=>x.ClienteId ==int.ClienteId)){
            let cAux = JSON.parse(JSON.stringify(int));
            cAux.firstRow=true;
            arrAux.push(cAux);
            arrAux.push(int);
        }else{
            arrAux.push(int)
        }   
    })

    for(var i=0;i<arrAux.length;i++){
        if(!arrAux[i].firstRow && arrAux[i+1] && arrAux[i+1].ClienteId != arrAux[i].ClienteId){
            arrAux[i].lastRow=true;
        }
    }

    return arrAux
}

function crearRowDatosTarjeta(arregloOriginal,tarjetaNumero){
    let arrAux = JSON.parse(JSON.stringify(arregloOriginal));
    let tarjeta = JSON.parse(JSON.stringify(arregloOriginal.filter(t=>t.TarjetaCreditoId == tarjetaNumero)));
    tarjeta = tarjeta[0];
    tarjeta.rowModificacion = true;
    tarjeta.firstRow = false;
    tarjeta.lastRow = false;

    arrAux.splice((arregloOriginal.findIndex(i=>i.TarjetaCreditoId == tarjetaNumero && !i.firstRow)+1), 0, tarjeta);
    return arrAux
}
function crearRowDatosIntegrante(arregloOriginal,integranteNumero){
    let arrAux = JSON.parse(JSON.stringify(arregloOriginal));
    let integrante = JSON.parse(JSON.stringify(arregloOriginal.filter(t=>t.ClienteId == integranteNumero)));
    integrante = integrante[0];
    integrante.rowModificacionIntegrante = true;
    integrante.firstRow = false;
    integrante.lastRow = false;
    
    arrAux.splice((arregloOriginal.findIndex(i=>i.ClienteId == integranteNumero && i.firstRow)+1), 0, integrante);
    
    return arrAux
}

class TablaIntegrantes extends Component {
    constructor(props) {
        super(props);
        this.state={
            viendoDatosTarjeta:null,
            viendoDatosIntegrante:null
        }
        this.verDatosTarjeta = this.verDatosTarjeta.bind(this);
        this.verDatosIntegrante = this.verDatosIntegrante.bind(this);
    }

    verDatosTarjeta(tarjetaNumero){
        this.setState({viendoDatosTarjeta:tarjetaNumero})
    }

    verDatosIntegrante(integranteNumero){
        
        this.setState({viendoDatosIntegrante:integranteNumero})
    }

    render() {

        const {integrantes, permisoModificacion, permisos} = this.props;
        let arregloTabla = [];
        let cuerpoTabla;
        
        if(integrantes && integrantes.length >0){
            arregloTabla = createArrayTable(integrantes);

            if(this.state.viendoDatosTarjeta){
                arregloTabla = crearRowDatosTarjeta(arregloTabla,this.state.viendoDatosTarjeta)
            }

            if(this.state.viendoDatosIntegrante){
                
                arregloTabla = crearRowDatosIntegrante(arregloTabla,this.state.viendoDatosIntegrante)
            }
        }


        cuerpoTabla = arregloTabla.map(int=><RowIntegrante 
            novedades={this.props.novedades.filter(nov=>nov.ClienteId == int.ClienteId)} 
            actions={this.props.actions} 
            data={this.props.data} viendoIntegrante={this.state.viendoDatosIntegrante != null} 
            verDatosIntegrante={this.verDatosIntegrante} 
            flechaArriba={this.state.viendoDatosTarjeta == int.TarjetaCreditoId} 
            verDatosTarjeta={this.verDatosTarjeta} integrante={int}
            permisoModificacion={permisoModificacion}
            permisos={permisos}
            />)
        
        return (
            <table className='tablaIntegrantesCuenta'>
                <thead>
                    <tr>
                        <th  width="195px">NOMBRE</th>
                        <th  width="199px">N°</th>
                        <th  width="90px">TIPO</th>
                        <th  width="90px">LIMITE</th>
                        <th  width="90px">ESTADO</th>
                        <th  width="120px">ACCIONES</th>
                    </tr>
                </thead>
                <tbody>
                    {cuerpoTabla}
                </tbody>
            </table>
        );
    }
}

export default TablaIntegrantes;